/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ naam: NonNullable<unknown> }} Planning_Rooster_Einde_SlepenInputs */

const nl_planning_rooster_einde_slepen = /** @type {(inputs: Planning_Rooster_Einde_SlepenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Einde van ${i?.naam} slepen`)
};

/**

* @param {Planning_Rooster_Einde_SlepenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_einde_slepen = /** @type {((inputs: Planning_Rooster_Einde_SlepenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Einde_SlepenInputs, { locale?: "nl" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_einde_slepen(inputs)
});
export { planning_rooster_einde_slepen as "planning.rooster.einde_slepen" }